import perfectCorp from 'Configuration/perfectCorp';

export const language = process.env.REACT_APP_LOCALE || 'en';
export const showQuiz = process.env.REACT_APP_SHOW_QUIZ === 'yes';
export const showPromo = process.env.REACT_APP_SHOW_PROMO === 'yes';
export const CUSTOM_QUIZ = process.env.REACT_APP_CUSTOM_QUIZ;
export const showFreshTab = process.env.REACT_APP_SHOW_FRESH_LENS_TAB === 'yes';
export const showLooksTab = process.env.REACT_APP_SHOW_LOOKS_TAB === 'yes';
export const showMakeupTab = process.env.REACT_APP_SHOW_MAKEUP_TAB === 'yes';
export const showClassicTab = (process.env.REACT_APP_REGION==="EMEA" || process.env.REACT_APP_SHOW_CLASSICTAB==='no' )? false : true;
export const showAllLensesTab = process.env.REACT_APP_SHOW_All_LENS_TAB === 'yes';
export const WEB_URL = process.env.REACT_APP_WEB_URL;
export const oneDayDefineLink = process.env.REACT_APP_1_DEFINE;
export const showNavbar = process.env.REACT_APP_SHOW_NAVBAR === 'yes';
export const showSidebar = process.env.REACT_APP_SHOW_SIDEBAR === 'yes';
export const showFloatButton = process.env.REACT_APP_SHOW_FLOATBUTTON === 'yes';
export const showCustomFloatButton = process.env.REACT_APP_SHOW_CUSTOMFLOATBUTTON === 'yes';
export const lensFinderLink = process.env.REACT_APP_LENS_FINDER_LINK;
export const storeLink = process.env.REACT_APP_FIND_ECP;
export const facebookLink = process.env.REACT_APP_SHARE_URL;
export const twitterLink = process.env.REACT_APP_SHARE_TWITTER;
export const instagramLink = process.env.REACT_APP_INSTAGRAM;
export const vkLink = process.env.REACT_APP_VK;
export const youtubeLink = process.env.REACT_APP_YOUTUBE;
export const promoLink = process.env.REACT_APP_PROMO_LINK;
export const kakaoLink = process.env.REACT_APP_KAKAO_LINK;
export const freeTrialLink = process.env.REACT_APP_FREE_TRIAL_LINK;
export const lensCareLink= process.env.REACT_APP_ABOUT_LENS_CARE_LINK;
export const kRAcuvueLink = process.env.REACT_APP_MY_ACUVUE_LINK;
export const MYDefinePromotionLink = process.env.REACT_APP_MYDefinePromotion_LINK;
export const showBoxShotImage = process.env.REACT_APP_SHOW_BOXSHOT_IMAGE === 'yes';
export const showBgGradient = process.env.REACT_APP_SHOW_BG_GRADIENT === 'yes';
export const showSubTitle = process.env.REACT_APP_BUTTON_SUB_TITLE === 'yes';
export const showAppsflyer = process.env.REACT_APP_SHOW_APPSFLYER === 'yes';
export const appsflyerLink = process.env.REACT_APP_APPSFLYER;
export const pageDefaultTitle = process.env.REACT_APP_DEFAULT_TITLE || 'ACUVUE® Define My Look';
export const redirectToEnglish= process.env.REACT_APP_ENGLISH;
export const redirectToArabic= process.env.REACT_APP_ARABIC;
export const enableBuyProductButton = process.env.REACT_APP_BUY_PRODUCT_IFRAME === 'yes';

export const API_DETAILS = {
  // apiEndpoint: language === 'zh' ? perfectCorp.chinaAPIUrl : perfectCorp.globalAPIUrl,
  // accessKey: language === 'zh' ? perfectCorp.chinaAPIKey : perfectCorp.globalAPIKey,
  apiEndpoint: language === 'zh' ? perfectCorp.chinaAPIUrl : (language==='arabia' || language==='arabia_en')? perfectCorp.middleEastAPIUrl: language==='ru'? perfectCorp.russiaAPIUrl :perfectCorp.globalAPIUrl,
  accessKey: language === 'zh' ? perfectCorp.chinaAPIKey : (language==='arabia' || language==='arabia_en')? perfectCorp.middleEastAPIKey: language==='ru'? perfectCorp.russiaAPIKey : perfectCorp.globalAPIKey,
};

export const CLASSIC_LENS_TAB = 'classicLens';
export const FRESH_LENS_TAB = 'freshLens';
export const All_LENS_TAB = 'allLens';
export const LOOKS_TAB = 'looks';
export const MAKEUP_TAB = 'makeUpLooks';
export const ID = 'id';
export const EYELASHES = 'eyelashes';
export const EYESHADOW = 'eyeshadow';
export const VM_STICKER = 'vmSticker';
export const DISPLAY_NONE = 'none';
export const DISPLAY_BLOCK = 'block';
export const CONTAINER_FLUID = true;

export const showProductDetailBuyModal = process.env.REACT_APP_SHOW_PRDOUCT_DETAIL_BUY_MODAL === 'yes';
export const showProductExternalBuy = process.env.REACT_APP_BUY_EXTERNAL_BUY === 'yes';
export const DEFAULT_PRODUCT_PARENT_TAB = process.env.REACT_APP_DEFAULT_PRODUCT_PARENT_TAB || CLASSIC_LENS_TAB;

export const LANG_AZ = 'az';
export const LANG_EN = 'en';
export const LANG_HK = 'hk';
export const LANG_ID = 'id';
export const LANG_JP = 'ja';
export const LANG_KR = 'ko';
export const LANG_MY = 'my';
export const LANG_SG = 'sg';
export const LANG_TH = 'th';
export const LANG_TWQ = 'twq';
export const LANG_ZH = 'zh';
export const LANG_VI = 'vi';
export const LANG_ARABIA_EN = 'arabia_en';
export const LANG_ARABIA = 'arabia';
export const LANG_RU = 'ru';
export const LANG_FIL = 'fil';
